import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { PlayList } from "../Components/Sounds/PlayList";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { BetManager } from "../Managers/BetManager";
import { Payline } from "../GameComponents/Payline";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Tweens } from "../Components/Effects/Tweens";
import { ModuleManager } from "../Managers/ModuleManager";
import { CustomUtils } from "../Utils/CustomUtils";
import { Reel2 } from "./Reel2";
import { Machine } from "../GameComponents/Machine";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { BaseView } from "../GameComponents/Base/BaseView";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    public static readonly FinishFirstInitWins: string = "eventFinishFirstInitWins";
    public static readonly FinishQuickWinCalculation: string = "eventFinishQuickWinCalculation";

    private _background: SwitchElement;

    public expandWildsPosition(index: number): Array<number> {
        let arr: Array<number> = [-1, -1];
        let found: boolean = false;
        for (let j: number = 0; j < this.currentSymbols[index].length; j++) {
            if (!found && this.currentSymbols[index][j].id === 10) {
                found = true;
                arr[0] = this.currentSymbols[index][j].x;
                arr[1] = this.currentSymbols[index][j].y;
            }
        }
        return arr;
    }

    public expandFirstSymbolPoistion(index: number): Array<number> {
        let arr: Array<number> = [-1, -1];
        let found: boolean = false;
        for (let j: number = 0; j < this.currentSymbols[index].length; j++) {
            if (!found) {
                found = true;
                arr[0] = this.currentSymbols[index][j].x;
                arr[1] = this.currentSymbols[index][j].y;
            }
        }
        return arr;
    }

    public expandWildsCount(index: number): number {
        let count: number = 0;
        for (let j: number = 0; j < this.currentSymbols[index].length; j++) {
            if (this.currentSymbols[index][j].id === 10) {
                count++;
            }
        }
        return count;
    }

    public expandWilds(index: number): void {
        for (let j: number = 0; j < this.currentSymbols[index].length; j++) {
            if (this.currentSymbols[index][j].id === 10) {
                let oldSymbol: Symbol = this.currentSymbols[index][j];
                let symbol: Symbol = this.symbols.getSymbol(15, this.currentSymbols[index][j].getCurrentCase());
                symbol.x = oldSymbol.x;
                symbol.y = oldSymbol.y;
                this.currentSymbols[index][j] = symbol;
                this.symbolsContainer.addChild(symbol);
                this.symbols.returnSymbol(oldSymbol);
            }
        }
    }

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        background?: SwitchElement,
    ): void {
        this._background = background;
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.currentReels = reelsData;

        for (let i = 0; i < reelsData[reelIndex].symbols.length; i++) {
            this.removeCurrentSymbol(reelIndex, i);
        }

        for (let j = 0; j < reelsData[reelIndex].symbols.length; j++) {
            this.addCurrentSymbol(reelIndex, j);
        }

        if (Reel2.Tease) {
            for (let j = 0; j < this.currentSymbols[reelIndex].length; j++) {
                if (this.currentSymbols[reelIndex][j].id !== 11) {
                    this.noWinSymbolsContainer.addChild(this.currentSymbols[reelIndex][j]);
                }
                this.currentSymbols[reelIndex][j].alpha = 1;
            }
        }

        this.tease(reelIndex);
        this.moveToTop();
    }

    private tease(reelIndex: number): void {
        const count = this.countScatters(reelIndex);

        let wilds: Array<Symbol>;
        if (ModuleManager.freespinsActive()) {
            wilds = FreespinsView.Wilds;
        } else {
            wilds = BaseView.Wilds;
        }

        if (reelIndex === 1 && count === 1) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                        PlayList.play("SND_BaseMoonHit01");
                        if (!Machine.Force) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                        } else {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                        }
                    } else {
                        if (Reel2.Tease) {
                            if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                            }
                            if (wilds[i] !== null) {
                                wilds[i].goToCase("NOWIN_LOOP");
                                if (ModuleManager.freespinsActive()) {
                                    wilds[4].goToCase("NOWIN_LOOP");
                                }
                            }
                        }
                    }
                }
            }
        } else if (reelIndex === 2 && count === 2) {
            if (Reel2.Tease) {
                if (this._background != null && this._background.getCurrentCase() == "NORMAL") {
                    this._background.goToCase("WIN_START");
                }
            }
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                        PlayList.play("SND_BaseMoonHit02");
                        if (!Machine.Force) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                        } else {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                        }
                    } else {
                        if (Reel2.Tease) {
                            if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                            }
                            if (wilds[i] !== null) {
                                wilds[i].goToCase("NOWIN_LOOP");
                                if (ModuleManager.freespinsActive()) {
                                    wilds[4].goToCase("NOWIN_LOOP");
                                }
                            }
                        }
                    }
                }
            }
        } else if (reelIndex === 2 && count === 1) {
            if (this._background != null && this._background.getCurrentCase() == "WIN") {
                this._background.goToCase("TO_NORMAL");
            }
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (
                        this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1 &&
                        this.currentSymbols[i][j].getCurrentCase() === "TEASING"
                    ) {
                        this.currentSymbols[i][j].goToCase("UNTEAS");
                    } else {
                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                        }
                        if (wilds[i] !== null && wilds[i].getCurrentCase() === "NOWIN_LOOP") {
                            wilds[i].goToCase("LOOP");
                            if (ModuleManager.freespinsActive() && wilds[4].getCurrentCase() === "NOWIN_LOOP") {
                                wilds[4].goToCase("LOOP");
                            }
                        }
                    }
                }
            }
        } else if (reelIndex === 3 && count === 3) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                        PlayList.play("SND_BaseMoonHit03");
                        if (!Machine.Force) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                        } else {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                        }
                    } else {
                        if (Reel2.Tease) {
                            if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                            }
                            if (wilds[i] !== null) {
                                wilds[i].goToCase("NOWIN_LOOP");
                                if (ModuleManager.freespinsActive()) {
                                    wilds[4].goToCase("NOWIN_LOOP");
                                }
                            }
                        }
                    }
                }
            }
        } else {
            if (reelIndex >= 3 && count !== 3) {
                if (this._background != null && this._background.getCurrentCase() == "WIN") {
                    this._background.goToCase("TO_NORMAL");
                }
                for (let i = 0; i <= reelIndex; i++) {
                    for (let j = 0; j < this.currentSymbols[i].length; j++) {
                        if (
                            this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1 &&
                            this.currentSymbols[i][j].getCurrentCase() === "TEASING"
                        ) {
                            this.currentSymbols[i][j].goToCase("UNTEAS");
                        } else {
                            if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                            }
                            if (wilds[i] !== null && wilds[i].getCurrentCase() === "NOWIN_LOOP") {
                                wilds[i].goToCase("LOOP");
                                if (ModuleManager.freespinsActive() && wilds[4].getCurrentCase() === "NOWIN_LOOP") {
                                    wilds[4].goToCase("LOOP");
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    private countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(this.getTeasingSymbol()) !== -1) {
                count++;
            }
        }

        return count;
    }

    private getTeasingSymbol(): number {
        return 12;
    }

    private getMinTeasingSymbolCount(): number {
        return 1;
    }

    protected finishFirstWins(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        //dont call cycle win, if we had feature game
        if (CustomUtils.hasFeatureGame()) {
            return;
        }

        if (this.currentWins && this.currentWins.length > 0) {
            // TODO
            if (this.currentWins.length > 0) {
                //if scatter win, we get 2 wins (cash, fs) - still single win
                if (
                    ModuleManager.freespinsEnabled() &&
                    this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter &&
                    this.currentWins.length == 2
                ) {
                    this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                    PlayList.play("SND_BaseRecapWinline");

                    return;
                }

                this.stopTimer();
                this.currentCycle = 0;
                this.cycleWins(true);
            } else {
                this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                PlayList.play("SND_BaseRecapWinline");

                if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                    PlayList.loop("SND_BaseRecapLoop");
                }
            }
        }
    }

    public showInitWins(wins: Array<Communication.Game.IWin>, win: number): void {
        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();
        this.stopTimer();

        if (wins != null && wins.length > 0) {
            this.showCustomInitWin();
            this.showFirstInitWins();
            // this.finishFirstInitWins();
        } else {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        }
        this.moveToTop();
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();
        this.stopTimer();

        if (wins != null && wins.length > 0 && this.currentWins != null && this.currentWins.length > 0) {
            this.currentMultiplierIndex = 0;

            for (let i = 0; i < this.multipliers.length; i++) {
                if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                    this.currentMultiplierIndex = i;
                }
            }

            if (!this.showCustomWin()) {
                this.showFirstWins();
            }
            this.moveToTop();
            return this.currentMultiplierIndex >= 3;
        } else {
            if (this._background != null && this._background.getCurrentCase() == "WIN") {
                this._background.goToCase("TO_NORMAL");
            }
            this.allSymbolsGoToCase(Symbol.CaseNormal, false);
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
            return false;
        }
    }

    protected showFirstWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        this.findNowinExpands();

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseWin);
        }
        this.moveToTop();

        this.startAnimation();
    }

    private findNowinExpands(): void {
        let wilds: Array<Symbol>;
        if (ModuleManager.freespinsActive()) {
            wilds = FreespinsView.Wilds;
        } else {
            wilds = BaseView.Wilds;
        }

        for (let i = 0; i < wilds.length; i++) {
            let foundWinSymbol: boolean = false;
            if (wilds[i] !== null) {
                for (let j = 0; j < this.symbolCount; j++) {
                    if (this.currentSymbols[i][j].id === 15 || (ModuleManager.freespinsActive() && i === 4)) {
                        for (let k = 0; k < this.currentWins.length; k++) {
                            if (!foundWinSymbol) {
                                if (this.currentWins[k].trigger === Communication.Game.WinTrigger.Payline) {
                                    const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                                        this.currentWins[k].paylineId,
                                        this.paylines.paylineDefinition,
                                    );
                                    if (this.currentWins[k].mask[i] === 1) {
                                        if (definition[i] === j) {
                                            foundWinSymbol = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (!foundWinSymbol) {
                    this.noWinSymbolsContainer.addChild(wilds[i]);
                    wilds[i].goToCase("NOWIN_LOOP");
                }
            }
        }
    }

    protected showFirstInitWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        this.findNowinExpands();

        for (let i = 0; i < this.currentWins.length; i++) {
            if (this.currentWins[i].trigger == Communication.Game.WinTrigger.Scatter) {
                this.winSymbolsGoToCase(i, Symbol.CaseWin + "_END", false);
            } else {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            this.winPaylineGoToCase(i, Payline.CaseWin);
        }

        this.moveToTop();

        this.startTimer(WinAnimator2.FinishFirstInitWins, 120);
    }

    protected finishFirstInitWins(): void {
        if (this.currentWins.length > 0) {
            if (this.currentWins.length > 0) {
                //if scatter win, we get 2 wins (cash, fs) - still single win
                if (
                    ModuleManager.freespinsEnabled() &&
                    this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter &&
                    this.currentWins.length == 2
                ) {
                    this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                    PlayList.play("SND_BaseRecapWinline");

                    return;
                }

                this.stopTimer();
                this.currentCycle = 0;
                this.cycleWins(true);
            } else {
                this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                PlayList.play("SND_BaseRecapWinline");

                if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                    PlayList.loop("SND_BaseRecapLoop");
                }
            }
        }
    }

    protected cycleWins(isFirst: boolean = false): void {
        if (this.currentWins == null) {
            return;
        }

        for (let i = 0; i < this.currentWins.length; i++) {
            if (i == this.currentCycle) {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false, false);
            } else {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false, true);
            }
        }

        switch (this.currentWins[this.currentCycle].payoutId) {
            case 1:
                PlayList.play("SND_BaseSymWood");
                break;
            case 2:
                PlayList.play("SND_BaseSymWood");
                break;
            case 3:
                PlayList.play("SND_BaseSymWood");
                break;
            case 4:
                PlayList.play("SND_BaseSymWood");
                break;
            case 5:
                PlayList.play("SND_BaseSymWood");
                break;
            case 6:
                PlayList.play("SND_BaseSymWood");
                break;
            case 7:
                PlayList.play("SND_BaseSymRabbit");
                break;
            case 8:
                PlayList.play("SND_BaseSymOwl");
                break;
            case 9:
                PlayList.play("SND_BaseSymWolf");
                break;
            case 10:
                PlayList.play("SND_BaseSymUnicorn");
                break;
            case 11:
                PlayList.play("SND_BaseSymElf");
                break;
        }

        super.cycleWins(isFirst);
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                const symbol = this.currentSymbols[i][definition[i]];
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    if (caseType === Symbol.CaseCycle) {
                        symbol.goToCase(Symbol.CaseCycle);
                        this.symbolsContainer.addChild(symbol);
                    } else if (caseType === Symbol.CaseWin) {
                        symbol.goToCase(Symbol.CaseWin);
                        this.symbolsContainer.addChild(symbol);
                    } else {
                        symbol.goToCase(caseType);
                    }

                    symbols.push(symbol);
                } else {
                    if (caseType === Symbol.CaseCycle) {
                        symbol.goToCase("CYCLE_NOWIN");
                        this.noWinSymbolsContainer.addChild(symbol);
                    }
                }
            }
        }

        return symbols;
    }

    protected createAnimations(): void {
        super.createAnimations();

        for (let i = 0; i < this.animationNames.length; i++) {
            if (this.childs[this.animationNames[i]]) {
                let animation = this.childs[this.animationNames[i]];
                animation.on("calculationFinished", this.onCalculationFinished.bind(this));
            }
        }
    }

    protected onCalculationFinished(): void {
        //win1 has no counting duration, so we want to override total win update
        this.emit(WinAnimator2.FinishQuickWinCalculation);
    }

    protected getAnimationIndex(): number {
        if (this.currentWins.length === 1 && this.currentWins[0].type === Communication.Game.WinType.freeSpins) {
            return 6;
        } else {
            return super.getAnimationIndex();
        }
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            (this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_2" ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_3") &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        this.moveToTop();

        return true;
    }
    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        super.addCurrentSymbol(reelIndex, symbolIndex);

        this.moveToTop();
    }

    protected allSymbolsGoToCase(caseType: string, noWin: boolean, force: boolean = false): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null) {
                    if (this.allowSymbolGoToCase(i, j, caseType)) {
                        symbol.goToCase(caseType, false, force);
                    }

                    if (noWin) {
                        this.noWinSymbolsContainer.addChild(symbol);
                    } else {
                        this.symbolsContainer.addChild(symbol);
                    }
                }
            }
        }

        this.moveToTop();
    }

    protected winSymbolsGoToCase(winIndex: number, caseType: string, useValue: boolean, scaleDown?: boolean): void {
        super.winSymbolsGoToCase(winIndex, caseType, useValue);

        //this.moveToTop();
    }

    public reset(showLastSymbols: boolean, spin = false): boolean {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j] != null) {
                    let symbol: Symbol = <any>this.currentSymbols[i][j];
                    symbol.removeDelay();
                    let container: ContainerElement = <any>symbol.children[0];
                    container.pivot.x = 0;
                    container.pivot.y = 0;
                    container.position.x = 0;
                    container.position.y = 0;
                    container.scale.x = 1;
                    container.scale.y = 1;
                    Tweens.removeTweens(container);
                }
            }
        }

        return super.reset(showLastSymbols, spin);
    }

    public visibleAllSymbols(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j] != null) {
                    this.currentSymbols[i][j].visible = true;
                }
            }
        }
    }

    protected onTimerComplete(): void {
        super.onTimerComplete();

        switch (this.timerStatus) {
            case WinAnimator2.FinishFirstInitWins:
                this.finishFirstInitWins();
                break;
        }
    }

    protected idle(): void {
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 4; j++) {
                const symbol = this.currentSymbols[i][j];
                if (
                    symbol &&
                    symbol.getCurrentCase() === Symbol.CaseNormal &&
                    symbol.getCurrentCase() !== Symbol.CaseEmpty
                ) {
                    symbol.goToDelayedCase(Symbol.CaseIdle, i * 16);
                }
            }
        }

        this.startTimer(WinAnimator.Idle, this.getIdleDelay());
    }

    protected getIdleDelay(): number {
        return 180;
    }

    protected getInitialIdleDelay(): number {
        return 30;
    }

    protected getIdleActiveElementsCount(): number {
        return 2;
    }

    protected moveToTop(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && symbol.id === 10) {
                    symbol.parent.addChild(symbol);
                }
            }
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && symbol.id === 11) {
                    symbol.parent.addChild(symbol);
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/